import React from "react";

const CommonSkeleton = ({
  count = 6,
  type = "card",
  columns = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
}) => {
  const CardSkeleton = () => (
    <div className="relative overflow-hidden rounded-3xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 p-5">
      {/* shimmer */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-linear-to-r from-transparent via-slate-100/70 dark:via-slate-700/20 to-transparent" />

      <div className="relative z-10">
        <div className="flex items-start justify-between">
          <div className="flex gap-3">
            <div className="w-12 h-12 rounded-2xl bg-slate-200 dark:bg-slate-700" />

            <div className="space-y-2">
              <div className="h-4 w-36 rounded-full bg-slate-200 dark:bg-slate-700" />
              <div className="h-3 w-20 rounded-full bg-slate-100 dark:bg-slate-600" />
            </div>
          </div>

          <div className="w-8 h-8 rounded-xl bg-slate-100 dark:bg-slate-700" />
        </div>

        <div className="mt-6 flex items-center justify-between">
          <div>
            <div className="h-3 w-16 rounded-full bg-slate-100 dark:bg-slate-700 mb-2" />
            <div className="h-5 w-12 rounded-full bg-slate-200 dark:bg-slate-600" />
          </div>

          <div className="flex gap-2">
            <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-slate-700" />
            <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-slate-700" />
          </div>
        </div>
      </div>
    </div>
  );

  const TableSkeleton = () => (
    <tbody>
      {Array.from({ length: count }).map((_, index) => (
        <tr
          key={index}
          className="border-b border-slate-100 dark:border-slate-700 relative overflow-hidden"
        >
          <td colSpan="5" className="absolute inset-0">
            <div className="h-full w-full -translate-x-full animate-[shimmer_2s_infinite] bg-linear-to-r from-transparent via-slate-100/60 dark:via-slate-700/20 to-transparent" />
          </td>

          <td className="px-6 py-5 relative">
            <div className="h-4 w-6 rounded-full bg-slate-200 dark:bg-slate-700" />
          </td>

          <td className="px-6 py-5 relative">
            <div className="h-4 w-40 rounded-full bg-slate-200 dark:bg-slate-700" />
          </td>

          <td className="px-6 py-5 relative">
            <div className="h-8 w-24 rounded-xl bg-slate-100 dark:bg-slate-700" />
          </td>

          <td className="px-6 py-5 relative">
            <div className="h-4 w-14 rounded-full bg-slate-200 dark:bg-slate-700" />
          </td>

          <td className="px-6 py-5 relative">
            <div className="flex justify-center gap-2">
              <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-slate-700" />
              <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-slate-700" />
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );

  if (type === "table") {
    return <TableSkeleton />;
  }

  return (
    <div className={`grid ${columns} gap-4`}>
      {Array.from({ length: count }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  );
};

export default CommonSkeleton;